require("core-js/features/promise");
// Note: About IE9 support, if we would need to support IE9, following is needed:
// * Different promise polyfill needed
//   require("promise/polyfill");
// * Polyfill for VueScrollTo to work.
//   require("raf/polyfill");


import Vue from "vue"
import { Component, Prop, Emit, Watch } from "vue-property-decorator"
import PreProductSelection from "../steps/pre-product-selection.vue"
import PreProductSelectionDisplay from "../steps/pre-product-selection-display.vue"
import ProductSelection from "../steps/product-selection.vue"
import ProductSelectionDisplay from "../steps/product-selection-display.vue"
import OfferProductSelectionDisplay from "../steps/offer-product-selection-display.vue"
import Authentication from "../steps/authentication.vue"
import CustomerInformation from "../steps/customer-information.vue"
import CustomerInformationDisplay from "../steps/customer-information-display.vue";
import CompanyInformationDisplay from "../steps/company-information-display.vue";
import CompanyInformation from "../steps/company-information.vue"
import MeteringPointInformation from "../steps/metering-point-information.vue"
import MeteringPointInformationDisplay from "../steps/metering-point-information-display.vue"
import NewContractSection from "../steps/new-contract-section.vue"
import { ValidationErrors, NewContract } from "../../new-contract-vue";
import { CustomerTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums"
import { IProductViewModel, IPriceListViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { NewContractEvents } from "../../new-contract-vue-events";
import { SectionState, ActionState, SectionMode } from "../../Default/common/section";
import { CustomerInformationChecker } from "../steps/customer-information";
import { CompanyInformationChecker } from "../steps/company-information";
import { PreProductSelectionChecker } from "../steps/pre-product-selection";
import { ProductSelectionChecker } from "../steps/product-selection";
import { MeteringPointInformationChecker } from "../steps/metering-point-information";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faBuilding } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import LoadingComponent from "../../../../../Scripts/vue-components/common/loading.vue";
import { HousingTypeEnum, HeatingTypeEnum, TarificationIdEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { IContractSettings } from "../../new-contract-vuex-store";

declare global {
    interface Window { offerRequest: boolean; }
}
window.offerRequest = window.offerRequest || false; //gets data passed from OfferIndex since not always is the offerRequest data correctly updated

library.add(faUser, faBuilding)
Vue.component('font-awesome-icon', FontAwesomeIcon)

@Component({
    components: {
        PreProductSelection,
        PreProductSelectionDisplay,
        ProductSelection,
        ProductSelectionDisplay,
        OfferProductSelectionDisplay,
        Authentication,
        CustomerInformation,
        CustomerInformationDisplay,
        CompanyInformation,
        CompanyInformationDisplay,
        MeteringPointInformation,
        MeteringPointInformationDisplay,
        NewContractSection,
        LoadingIndicator: LoadingComponent
    },
})

export default class PhaseNewContract extends Vue {
    // Map store state's properties to computed properties.
    get contract(): IContractViewModel { return this.$store.state.contract; }    
    get selectedProduct(): IProductViewModel { return this.$store.state.selectedProduct; }
    get offerProducts(): string[] { return this.$store.state.offerProducts; }
    get selectedPriceList(): IPriceListViewModel { return this.$store.state.selectedPriceList; }
    get customerType(): CustomerTypeEnum { return this.contract.CustomerType; } 
    get processBrand(): string { return this.contract.Brand; }
    get preSelectedProductId(): number { return this.$store.state.preSelectedProductId; }
    get preSelectedPriceListId(): number { return this.$store.state.preSelectedPriceListId; }
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    isCustomerInCIS(payload: { pin: string }) { return this.$store.dispatch("isCustomerInCIS", payload); }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }
    get email(): string { return this.contract.CustomerType == CustomerTypeEnum.CONSUMER ? this.contract.Customer.Email : this.contract.Company.Email };
    get showAuthentication(): boolean { return this.$store.state.isAuthenticated; } 
    get hideAuthenticationForcedText(): boolean { return this.$store.state.isAuthenticated; }
    setOfferRequest(payload: { offerRequest: boolean }) { return this.$store.dispatch("offerRequest", payload); }

    @Prop()
    public validationErrors: ValidationErrors;

    @Prop()
    public testMode: boolean;

    @Prop({ default: "/NewContract/Contract/" })
    public baseUrl: string;

    @Emit()
    productsInvalidated() {}

    @Emit()
    nextPhase() { }

    authenticate() {
         //used in emit thingy so needs to be here
    }


    @Watch('customerType')
    onCustomerTypeChanged(newVal: CustomerTypeEnum, oldVal: CustomerTypeEnum) {
        this.showLoadingIndicator = true;
        if (newVal === CustomerTypeEnum.COMPANY) {
            this.sections.product.setSiblings(this.sections.preProduct, this.sections.company);
            this.sections.meteringPoint.setSiblings(this.sections.company, null);
            //need to build chain with company in it, there are situations at this point where it does not link to meteringpoint correctly
            SectionState.formChain(this.sections.preProduct, this.sections.product, this.contract?.CustomerType === CustomerTypeEnum.COMPANY ? this.sections.company : this.sections.company, this.sections.meteringPoint);
        }
        else {
            this.sections.product.setSiblings(this.sections.preProduct, this.sections.customer);
            this.sections.meteringPoint.setSiblings(this.sections.customer, null);
        }
    }

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    SectionMode: typeof SectionMode = SectionMode;
    ActionState: typeof ActionState = ActionState;

    sections: {
        preProduct: SectionState;
        product: SectionState;
        customer: SectionState;
        company: SectionState;
        meteringPoint: SectionState;
    } = null;

    customerExistanceChecked: boolean;
    checkedPin: string;
    showLoadingIndicator: boolean = false;
    membershipSelected: boolean = false;
    constructor() {
        super();
        this.customerExistanceChecked = false;
        this.checkedPin = "";        
        this.sections = {
            preProduct: new SectionState("pre-product", () => this.$refs.preProduct),
            product: new SectionState("product", () => this.$refs.product),
            customer: new SectionState("customer", () => this.$refs.customer),
            company: new SectionState("company", () => this.$refs.company),
            meteringPoint: new SectionState("metering-point", () => this.$refs.meteringPoint),
        };
        if (this.processBrand && (this.processBrand.toLowerCase() == "priima" || this.processBrand.toLowerCase() == "priimaplus")) {
            console.log("Forming priima section chain");
            SectionState.formChain(this.sections.product, this.contract?.CustomerType === CustomerTypeEnum.COMPANY ? this.sections.company : this.sections.customer, this.sections.meteringPoint);
        }
        else {
            console.log("Forming section chain");
            SectionState.formChain(this.sections.preProduct, this.sections.product, this.contract?.CustomerType === CustomerTypeEnum.COMPANY ? this.sections.company : this.sections.customer, this.sections.meteringPoint);
        }
        
    }

    created() {
        if (this.isPriima()) {
            this.$store.dispatch("changeValue", { key: "customerType", value: CustomerTypeEnum.CONSUMER }).then(() => {
                this.$store.dispatch("changeValue", { key: "housingType", value: HousingTypeEnum.HOUSE }).then(() => {
                    this.$store.dispatch("changeValue", { key: "heatingType", value: HeatingTypeEnum.ELECTRICITY }).then(() => {
                        this.$store.dispatch("changeValue", { key: "tarification", value: TarificationIdEnum.SINGLETARIF }).then(() => {
                            if (this.isPriimaplus()) {
                                this.$store.dispatch("changeValue", { key: "customerType", value: CustomerTypeEnum.COMPANY }).then(() => {
                                    console.log("Company customer")
                                    this.proceedToProductSelection();
                                });
                            }
                            else {
                                this.proceedToProductSelection();
                            }
                        });
                    });
                });
            });
        }
    }

    mounted() {
        console.log("Phase mounted!");       
        NewContractEvents.addValidationFailedListener(this.validationFailed);
        if (this.$store.state.newContractInitialized) {
            // New contract has already been initialized (i.e. we are coming back from confirmation phase to modify our contract.)
            // In this case we just initialize the sections' states (or the UI).
            if (this.contract?.CustomerType === CustomerTypeEnum.COMPANY) {
                this.sections.company.customerInfoGiven = true;
            }
            else {
                this.sections.customer.customerInfoGiven = true;
            }
            this.initializeSections();
        }
        else {
            // New contract has not been initialize, let's register listener for initialization. That listener takes care of
            // sections' initialization after module is initialized.
            NewContractEvents.addNewContractInitializedListener(this.newContractInitialized);
        }
        
    }

    beforeDestroy() {
        NewContractEvents.removeValidationFailedListener(this.validationFailed);
        NewContractEvents.removeNewContractInitializedListener(this.newContractInitialized);
    }

    proceedToProductSelection() {
        console.log("Proceed to product selection!");
        this.sections.preProduct.proceed();
    }

    productSelected(product: IProductViewModel, priceList: IPriceListViewModel) {
        let self = this;
        this.sections.product.proceed();
    }

    modifyPreProductSelection() {
        this.sections.preProduct.enter();
    }

    modifyProductSelection() {
        this.sections.product.enter();
    }

    customerTypeSelected() {
        if (this.isPriima()) {
            this.sections.product.enter();
        }
        else {
            this.sections.preProduct.enter();
        }
        this.showLoadingIndicator = false;
    }

    proceedToMeteringPoint() {
        this.sections.product.proceed();
    }

    validationFailed(errors: ValidationErrors) {
        this.$nextTick(() => {
            let errorFound = false;
            if (!this.isPriima()) {
                if (PreProductSelectionChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.preProduct.enterModify();
                }
            }
            if (!errorFound && ProductSelectionChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.product.enterModify();
            }

            if (!errorFound && CustomerInformationChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.customer.enterModify();
            }

            if (!errorFound && CompanyInformationChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.company.enterModify();
            }

            if (!errorFound && MeteringPointInformationChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.meteringPoint.enterModify();
            }

            let validationIds = errors.getAllKeys();
            let selector = "";
            validationIds.forEach((id) => {
                if (selector)
                    selector += ",";
                selector += "[data-validation-id='" + id + "']";
            });

            let nodeList = this.$el.querySelectorAll(selector);
            let elements = [];
            for (let i = 0; i < nodeList.length; ++i) {
                elements.push(nodeList.item(i));
            }

            elements.sort(function(a, b) {
                if (a === b) return 0;
                if (!a.compareDocumentPosition) {
                    // support for IE8 and below
                    return a.sourceIndex - b.sourceIndex;
                }
                if (a.compareDocumentPosition(b) & 2) {
                    // b comes before a
                    return 1;
                }
                return -1;
            });

            //if (elements.length != 0) {
            //    VueScrollTo.scrollTo(elements[0]);
            //}
        });
    }

    customerValueUpdated(allSet: boolean) {
        if (allSet) {
            console.log("All customer values have been set!");
        }
    }

    companyValueUpdated(allSet: boolean) {
        if (allSet) {
            console.log("All company values have been set!");
        }
    }

    getSectionMode(allSet: boolean, previousSectionMode: SectionMode) {
        let mode = allSet ? SectionMode.Display : SectionMode.Edit;
        if (previousSectionMode != null) {
            if (mode == SectionMode.Edit && previousSectionMode != SectionMode.Display)
                mode = SectionMode.Hidden;
        }
        return mode;
    }

    initializeSections() {
        const customerTypeSelected = this.contract.CustomerType != CustomerTypeEnum.NOTSET;
        this.sections.preProduct.initializeMode(this.isPriima() ? true : PreProductSelectionChecker.isAllSet(this.contract), customerTypeSelected ? SectionMode.Display : SectionMode.Edit);
        this.sections.product.initializeMode(this.isPriima() ? false : ProductSelectionChecker.isAllSet(this.contract), this.isPriima() ? SectionMode.Display : null);
        if (this.contract.CustomerType == CustomerTypeEnum.CONSUMER) {
            this.sections.customer.initializeMode(CustomerInformationChecker.isAllSet(this.contract) && this.contract.AuthenticateQuestionAccepted);
        }
        else if (this.contract.CustomerType == CustomerTypeEnum.COMPANY) {
            this.sections.company.initializeMode(CompanyInformationChecker.isAllSet(this.contract));
        }
        else {
            this.sections.customer.mode = SectionMode.Hidden;
        }
        this.sections.meteringPoint.initializeMode(MeteringPointInformationChecker.isAllSet(this.contract));
        this.sections.preProduct.scrollToFirstEdit();
    }

    newContractInitialized() {
        console.log("New contract initialized!");
        if (!this.offerRequest && window.offerRequest) {
            this.setOfferRequest({ offerRequest: window.offerRequest });
        }

        this.initializeSections();
    }

    getCustomerProceedActionState(): ActionState {
        if (this.contract.AuthenticateQuestionAccepted && this.contract.StrongContractAuthentication) {
            return ActionState.Enabled;
        }
        return ActionState.Hidden;
    }

    hasMembership(): boolean {
        if ((!this.contract.PreSelectedMembership || this.contract.PreSelectedMembership.length == 0) && (this.contract.Customer.CustomerMemberships || this.contract.MembershipCode)) {
            return true;
        }
        return false;
    }

    isPriima(): boolean {
        if (this.processBrand && (this.processBrand.toLowerCase() == "priima" || this.processBrand.toLowerCase() == "priimaplus")) {
            return true;
        }
        return false;
    }

    isPriimaplus(): boolean {
        if (this.processBrand && this.processBrand.toLowerCase() == "priimaplus") {
            return true;
        }
        return false;
    }

    productSelectionPhaseTitle(): string {
        let title = "Sopimusvalikoima";
        if (this.isPriima()) {
            title = "Sähkötuote ja tuotantotapa";
        }
        return title;
    }

    phaseNumber(defaultnumber : number): number {
        let result: number = defaultnumber;
        if (this.isPriima()) {
            result--;
        }
        return result;
    }

    priimaplusUrl(): string {
        let url = this.baseUrl + "Index";
        url += "?selectedProductId=" + this.contractSettings.PriimaPlusProductId;
        url += "&selectedPriceListId=" + this.contractSettings.PriimaPlusPriceListId;
        return url;
    }

    movingUrl(): string {
        if ((this.contract.Customer && this.contract.Customer.TrustedSource) || (this.contract.Company && this.contract.Company.TrustedSource)) {
            return this.baseUrl + "NewContractCustomerSelection?moving=true";
        }
        else {
            return this.baseUrl +"EndProcess?moving=true";
        }
    }

    showPriimaplusLink(): boolean {
        if (!this.contract.Customer.TrustedSource && !this.contract.Company.TrustedSource && !this.isPriima() && !this.isPriimaplus()) {
            return true;
        }
        return false;
    }

    enabledOfferRequestButton(): boolean {
        let result = (this.email != null && this.email != "") ? true : false;
        if (this.contract.CustomerType == CustomerTypeEnum.CONSUMER) {
            let cust = this.contract.Customer;
            result = result && (cust.FirstName != null && cust.FirstName != "" && cust.LastName != null && cust.LastName != "" && cust.Phone != null && cust.Phone != "");
        }
        else if(this.contract.CustomerType == CustomerTypeEnum.COMPANY) {
            let comp = this.contract.Company;
            result = result && (comp.CompanyName != null && comp.CompanyName != "" && comp.Phone != null && comp.Phone != "");
        }
        let mp = this.contract.MeteringPoint;
        result = result && mp.Address.Street != null && mp.Address.Street != "" && mp.Address.Zip != null && mp.Address.Zip != "";

        result = result && ((this.selectedPriceList != null && this.selectedPriceList.Id > 0 && this.selectedProduct != null && this.selectedProduct.Id > 0) || this.offerProducts.length > 0);
        return result;
    }

    sendOfferRequest(): void {
        window.location.href = this.baseUrl + "sendoffer?offerEmail=" + this.email;
    }
}